/* eslint-disable no-unused-vars */
import axios from "../../axios";

const urlReport = "/user/operations/report-deal";
const state = {};

const actions = {
  async getReport({ commit }, query) {
    try {
      const response = await axios.get(
        `${urlReport}?${new URLSearchParams(query)}`
      );
      return response.data.data;
    } catch (e) {
      console.log("exception: ", e);
    }
  },
  async getReportFreezingTransferDeal({ commit }, query) {
    try {
      const response = await axios.get(
        `/user/operations/report-freezing-transfer-deal?${new URLSearchParams(
          query
        )}`
      );
      return response.data.data;
    } catch (e) {
      console.log("exception: ", e);
    }
  },
};

const mutations = {};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
